import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Practical case",
  layout: {
    type: "customCase010205",
    options: {
      pages: [
        { image: `${config.ASSETS_URL}/01/case-02/slide05-view01-image.svg` },
        {
          images: [
            `${config.ASSETS_URL}/01/case-02/slide05-view02-image01.svg`,
            `${config.ASSETS_URL}/01/case-02/slide05-view02-image02.svg`,
            `${config.ASSETS_URL}/01/case-02/slide05-view02-image03.svg`,
          ],
        },
        { image: `${config.ASSETS_URL}/01/case-02/slide05-view03-image.svg` },
        {
          images: [
            `${config.ASSETS_URL}/01/case-02/slide05-view04-image01.svg`,
            `${config.ASSETS_URL}/01/case-02/slide05-view04-image02.svg`,
          ],
        },
        { image: `${config.ASSETS_URL}/01/case-02/slide05-view05-image.svg` },
        {
          image: `${config.ASSETS_URL}/01/case-02/slide05-view06-image.svg`,
          video: `${config.ASSETS_URL}/01/case-02/slide05-view06-video.mp4`,
        },
        {
          images: [
            `${config.ASSETS_URL}/01/case-02/slide05-view07-image01.svg`,
            `${config.ASSETS_URL}/01/case-02/slide05-view07-image02.svg`,
          ],
        },
        { image: `${config.ASSETS_URL}/01/case-02/slide05-view08-image.svg` },
        { image: `${config.ASSETS_URL}/01/case-02/slide05-view09-image.svg` },
        { image: `${config.ASSETS_URL}/01/case-02/slide05-view10-image.svg` },
      ],
    },
  },
};

export default principle;
